import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getAllUsersAdmin, deleteUser } from "../../axios/axiosFunctions";
import { DataGrid } from '@mui/x-data-grid';
import { Typography, Button, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { getColumnsHome } from "../../utils/homeTable";
import { DeleteConfirmationModal, CreateUserModal } from "../../components/common";
import { AssessmentContext } from "../../contexts/assessments";

const AdminHome = () => {

  const navigate = useNavigate();
  const { refetchAssessments } = useContext(AssessmentContext);
  const [rows, setRows] = useState([]);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const fetchUsers = async () => {
    const users = await getAllUsersAdmin();
    if (users) {
      const tempRows = users.map((u) => ({
        id: u.userId,
        firstName: u.firstName,
        lastName: u.lastName,
        companyName: u.company,
        email: u.email,
        assessments: u.assessments || [],
        reviewerAssessments: u.reviewerAssessments || [],
        revieweeAssessments: u.revieweeAssessments || [],
        teams: u.teams || [],
        roles: u.roles || [],
        source: u.source || "Admin",
      }));
      setRows(tempRows);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleCellClick = (e) => {
    const { row, colDef } = e;
    if (colDef.field === "lastName" || colDef.field === "firstName") {
      navigate(`/profile/${row.id}`);
    }
  }

  const handleEdit = (userId) => {
    navigate(`/profile/${userId}`);
  }

  const handleDelete = (userId) => {
    setUserIdToDelete(userId);
    setOpenDialogDelete(true);
  }

  const handleCloseDialogDelete = () => {
    setOpenDialogDelete(false);
    setUserIdToDelete(null);
  }

  const confirmDelete = async () => {
    if (!userIdToDelete) return;

    const res = await deleteUser(userIdToDelete);

    if (!res || (res.success === false)) {
      return;
    }
    setRows(rows.filter(row => row.id !== userIdToDelete));
    refetchAssessments();
    handleCloseDialogDelete();
  }

  const handleUserCreated = () => {
    setOpenCreateModal(false);
    fetchUsers();
    refetchAssessments();
  };

  const columns = getColumnsHome(handleEdit, handleDelete);

  return (
    <>
      <Typography variant="h3" fontWeight={500} color="secondary">Home</Typography>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "50px", marginBottom: "50px" }}>
        <Typography variant="h4" fontWeight={400} color="secondary">Users</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenCreateModal(true)}>
          Add User
        </Button>
      </Box>
      <DataGrid
        columns={columns}
        rows={rows}
        onCellClick={handleCellClick}
        showToolbar
        getRowHeight={() => "auto"}
        sx={{
          '& .MuiDataGrid-cell': {
            alignItems: 'center',
            py: 1,
          },
        }}
      />
      <DeleteConfirmationModal openDialog={openDialogDelete} closeDialog={handleCloseDialogDelete} title="Delete User" message="Are you sure you want to delete this user?" onConfirm={confirmDelete} />
      <CreateUserModal open={openCreateModal} onClose={() => setOpenCreateModal(false)} onUserCreated={handleUserCreated} />
    </>
  )
}

export default AdminHome
